import { useState, useCallback } from 'react';

/**
 * Hook para gerenciar filtros compartilhados entre as abas Vendas e Recebimentos
 * Mantém os filtros ativos mesmo ao trocar de aba
 */
export const useSharedFilters = () => {
  // Estados dos filtros compartilhados
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOperators, setSelectedOperators] = useState(new Set());
  const [selectedFlags, setSelectedFlags] = useState(new Set());
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState(new Set());
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });

  // Funções para atualizar os filtros
  const updateSearchTerm = useCallback((term) => {
    setSearchTerm(term);
  }, []);

  const updateSelectedOperators = useCallback((operators) => {
    setSelectedOperators(operators);
  }, []);

  const updateSelectedFlags = useCallback((flags) => {
    setSelectedFlags(flags);
  }, []);

  const updateSelectedPaymentMethods = useCallback((paymentMethods) => {
    setSelectedPaymentMethods(paymentMethods);
  }, []);

  const updateDateRange = useCallback((range) => {
    setDateRange(range);
  }, []);

  // Função para limpar todos os filtros
  const clearAllFilters = useCallback(() => {
    setSearchTerm('');
    setSelectedOperators(new Set());
    setSelectedFlags(new Set());
    setSelectedPaymentMethods(new Set());
    setDateRange({
      startDate: null,
      endDate: null
    });
  }, []);

  // Função para verificar se há filtros ativos
  const hasActiveFilters = useCallback(() => {
    return searchTerm || 
      selectedOperators.size > 0 || 
      selectedFlags.size > 0 || 
      selectedPaymentMethods.size > 0 || 
      dateRange.startDate || 
      dateRange.endDate;
  }, [searchTerm, selectedOperators, selectedFlags, selectedPaymentMethods, dateRange]);

  return {
    // Estados
    searchTerm,
    selectedOperators,
    selectedFlags,
    selectedPaymentMethods,
    dateRange,
    
    // Funções de atualização
    updateSearchTerm,
    updateSelectedOperators,
    updateSelectedFlags,
    updateSelectedPaymentMethods,
    updateDateRange,
    clearAllFilters,
    hasActiveFilters
  };
};
